import { TbCheck, TbDeviceDesktop, TbMoon, TbSun } from "react-icons/tb";
import type { ActionIconProps, MenuProps, TooltipProps } from "@mantine/core";
import {
  ActionIcon,
  Menu,
  Tooltip,
  rem,
  useMantineColorScheme,
} from "@mantine/core";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Color Scheme Action Icon
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

type ColorSchemeActionIconProps = Omit<ActionIconProps, "children"> & {
  readonly menuProps?: MenuProps;
  readonly tooltipProps?: Omit<TooltipProps, "label" | "children">;
};

export function ColorSchemeActionIcon({
  menuProps,
  tooltipProps,
  ...actionIconProps
}: ColorSchemeActionIconProps) {
  const { colorScheme, setColorScheme } = useMantineColorScheme({
    keepTransitions: false,
  });

  return (
    <Menu position="bottom" {...menuProps}>
      <Menu.Target>
        <Tooltip {...tooltipProps} label="Color Scheme">
          <ActionIcon variant="default" {...actionIconProps}>
            {colorScheme === "light" ? (
              <TbSun />
            ) : colorScheme === "dark" ? (
              <TbMoon />
            ) : (
              <TbDeviceDesktop />
            )}
          </ActionIcon>
        </Tooltip>
      </Menu.Target>

      <Menu.Dropdown w={rem(164)}>
        <Menu.Item
          leftSection={<TbSun />}
          rightSection={colorScheme === "light" && <TbCheck />}
          onClick={() => setColorScheme("light")}
        >
          Light
        </Menu.Item>

        <Menu.Item
          leftSection={<TbMoon />}
          rightSection={colorScheme === "dark" && <TbCheck />}
          onClick={() => setColorScheme("dark")}
        >
          Dark
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item
          leftSection={<TbDeviceDesktop />}
          rightSection={colorScheme === "auto" && <TbCheck />}
          onClick={() => setColorScheme("auto")}
        >
          System
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
